import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as MagnifyingGlassIcon } from "../assets/icons/dashboard/magnifyingglass.svg";

export default function DestinationPromptModal({ isOpen, onClose }) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-sm rounded-3xl bg-white p-6 shadow-2xl border border-slate-100 flex flex-col items-center text-center animate-scale-up"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="destination-prompt-title"
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-400 hover:text-slate-700 flex items-center justify-center text-sm font-bold transition"
          aria-label={t("common.close", "ปิด")}
        >
          ✕
        </button>

        <div className="w-20 h-20 rounded-full border-4 border-blue-100 bg-blue-50 flex items-center justify-center text-blue-600 mt-1 mb-3 shadow-inner">
          <MagnifyingGlassIcon className="w-9 h-9" />
        </div>

        <h3 id="destination-prompt-title" className="text-xl font-extrabold text-slate-900 leading-snug">
          {t("user.layout.destinationPromptTitle", "โปรดระบุห้องที่ท่านต้องการจะไป")}
        </h3>
        <p className="text-sm text-slate-500 mt-2 px-2 leading-relaxed">
          {t("user.layout.destinationPromptSub", "ค้นหาและเลือกห้องหรือสถานที่ปลายทางเพื่อเริ่มการนำทาง")}
        </p>

        <button
          type="button"
          onClick={onClose}
          className="mt-6 w-full h-12 rounded-xl bg-blue-600 hover:bg-blue-700 active:scale-[0.98] text-white font-bold text-base flex items-center justify-center gap-2 shadow-lg shadow-blue-500/25 transition"
        >
          <span>{t("user.layout.destinationPromptConfirm", "ตกลง")}</span>
        </button>
      </div>
    </div>
  );
}
